import React, { useState, useEffect } from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  IconButton,
  Typography,
} from "@material-ui/core";
import { AvatarParticipante } from "views/Tablero/Components/Item";
import serviciosTablero from "utils/serviciosTablero";
import DeleteIcon from "@material-ui/icons/Delete";

const MiembrosTarjeta = ({ miembros, onEliminarMiembro }) => {
  return (
    <Grid>
      <List>
        {miembros?.length > 0 ? (
          miembros?.map((miembro) => (
            <ListItem key={miembro.idusuario}>
              <ListItemAvatar>
                <AvatarParticipante
                  infoColaborador={{
                    nombre: miembro.nombre,
                    correo: miembro.correo,
                    color: miembro.color,
                    avatar: miembro.avatar,
                  }}
                  noFlex
                />
              </ListItemAvatar>
              <ListItemText primary={miembro.nombre} />
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => onEliminarMiembro(miembro.idusuario)}
                style={{ color: "#f44336" }}
              >
                <DeleteIcon />
              </IconButton>
            </ListItem>
          ))
        ) : (
          <Grid>
            <Typography>{" No hay miembros"}</Typography>
          </Grid>
        )}
      </List>
    </Grid>
  );
};

export default MiembrosTarjeta;
